import { useState, useRef, useEffect } from "react";

const ReadMoreText = ({
  text,
  maxLines = 3,
  color="var(--Prime-Blue, #0A1D39)",
  fontSize="15px"
}: {
  text: string;
  maxLines: number;
  color?:string
  fontSize?:string
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [needsTruncation, setNeedsTruncation] = useState(false);
  const textRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // Check if text needs truncation
    if (textRef.current) {
      const lineHeight = parseInt(getComputedStyle(textRef.current).lineHeight);
      const maxHeight = lineHeight * maxLines;
      setNeedsTruncation(textRef.current?.scrollHeight > maxHeight);
    }
  }, [text, maxLines]);

  return (
    <div>
      <div
        ref={textRef}
        style={{
          display: "-webkit-box",
          WebkitLineClamp: isExpanded ? "none" : maxLines,
          WebkitBoxOrient: "vertical",
          overflow: "hidden",
          lineHeight: "1.5",
          fontSize: fontSize,
        }}
        // className="text-sm"
      >
        {text}
      </div>
      {needsTruncation && (
        <button
        type="button"
          onClick={(e) => {
            e.stopPropagation();
            setIsExpanded(!isExpanded);
          }}
          style={{
            color: color,
            background: "none",
            border: "none",
            cursor: "pointer",
            fontWeight: "600",
            marginTop: "4px",
          }}
        >
          {isExpanded ? "Read less" : "Read more"}
        </button>
      )}
    </div>
  );
};

export default ReadMoreText;
